// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2e20q","upload":"Small_upload__3PhEg","imageWrap":"Small_imageWrap__2Pl2I","removeBtn":"Small_removeBtn__2-uwV"};